import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { projectViewFreelancerUsersBackend } from './project-view-freelancer-users.backend';
import { projectViewFreelancerUsersReducer } from './project-view-freelancer-users.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'projectViewFreelancerUsers',
      projectViewFreelancerUsersReducer,
    ),
    BackendModule.forFeature(
      'projectViewFreelancerUsers',
      projectViewFreelancerUsersBackend,
    ),
  ],
})
export class DatastoreProjectViewFreelancerUsersModule {}
